import React, { Component } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import { connect } from "react-redux";
import _ from "lodash";

import Wrapper from "../components/Wrapper";
import Header from "../components/Header";
import Body from "../components/Body";
import TopBar from "../components/TopBar";
import Loading from "../components/Loading";
import SubmitButton from "../components/SubmitButton";

import Typography from "@material-ui/core/Typography";
import Icon from "@material-ui/core/Icon";
import Modal from "@material-ui/core/Modal";
import { getPackages } from "../api";
import { dispatch } from "./../store";
import numeral from "numeral";

const fontDefault = {
  fontFamily: "thonburiregular",
  fontStyle: "normal",
  color: "rgb(14 22 44)"
};

function humanize(str) {
  return str
    .replace(/^[\s_]+|[\s_]+$/g, "")
    .replace(/[_\s]+/g, " ")
    .replace(/^[a-z]/, function(m) {
      return m.toUpperCase();
    });
}

const styles = {
  textTopBar: {
    ...fontDefault,
    color: "#333333",
    fontSize: "18px",
    fontWeight: "bold"
  },
  card: {
    backgroundColor: "white",
    borderRadius: "8px",
    boxShadow:
      "0 0 13px 0 rgba(35, 57, 120, 0.14), 0 4px 6px 0 rgba(35, 57, 120, 0.1)",
    padding: "16px",
    marginBottom: "16px"
  },
  wrapper: {
    margin: "16px",
    marginTop: "24px"
  },
  cardHead: {
    ...fontDefault,
    fontSize: "16px",
    fontWeight: "bold",
    textAlign: "center",
    fontFamily: "San Francisco Text"
  },
  cardPriceNumber: {
    ...fontDefault,
    fontFamily: "San Francisco Text",
    fontSize: "30px",
    fontWeight: "bold",
    marginTop: "0px",
    marginBottom: "0px",
    textAlign: "center",
    marginTop: "16px",
    marginBottom: "24px"
  },
  item: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginTop: "2px",
    marginBottom: "2px"
  },
  itemName: {
    ...fontDefault,
    fontSize: "14px",
    color: "#878b96"
  },
  itemValue: {
    ...fontDefault,
    fontSize: "14px",
    fontWeight: "bold"
  },
  cardHeadContainer: {
    position: "relative"
  },
  button: {
    cursor: "pointer",
    width: "18px",
    height: "18px",
    position: "absolute",
    right: 0,
    top: 0
  },
  modalContainer: {
    overflow: "auto",
    outline: 0,
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    position: "absolute",
    width: "90%",
    maxHeight: "80%",
    backgroundColor: "white",
    borderRadius: "8px"
  },
  modalContainerContent: {
    padding: "16px"
  },
  modalHead: {
    ...fontDefault,
    fontSize: "16px",
    fontWeight: "bold",
    marginBottom: "8px"
  },
  modalValue: {
    ...fontDefault,
    fontSize: "16px",
    color: "#878b96"
  }
};

class App extends Component {
  state = {
    modalVisible: false,
    isLoading: true
  };

  backToPreviousPage = () => {
    const {
      history: { push }
    } = this.props;
    push("/home-old");
    document.getElementById("rootScreen").scrollTo(0, 0);
  };

  goToNextPage = selectedPackage => () => {
    const { auth = {} } = this.props;
    const { user = {}, buyFor = "self" } = auth;
    const {
      history: { push }
    } = this.props;
    const balance = _.get(user, "balance", 0);
    if (selectedPackage.total_prem > parseFloat(balance || 0) / 100) {
      const mixpanel = _.get(window, "mixpanel", undefined);
      if (!!mixpanel) {
        mixpanel.track("Insurance Corona Error", {
          "Insurance type": "Dhipaya Corona",
          Insurer: "Dhipaya",
          "Error message": "Selection-Insufficient fund",
          "Error code": "E10501",
          Recipient: buyFor === "self" ? "Buy for self" : "Buy for others"
        });
      }
      const dataLayer = _.get(window, "dataLayer", undefined);
      if (!!dataLayer) {
        dataLayer.push({
          event: "error-page", // Required
          errorMsg: "Selection-Insufficient fund"
        });
      }
      push("/error-payment");
      document.getElementById("rootScreen").scrollTo(0, 0);
      return;
    }
    const mixpanel = _.get(window, "mixpanel", undefined);
    if (!!mixpanel) {
      mixpanel.track("Insurance Corona Selection", {
        Insurer: "Dhipaya",
        "Insurance type": "Dhipaya Corona",
        "Insurance package": selectedPackage.name,
        Amount: selectedPackage.total_prem
      });
    }
    dispatch({ type: "", selectedPackage });
    push("/personal-info");
    document.getElementById("rootScreen").scrollTo(0, 0);
  };

  fetchPackage = async () => {
    try {
      const response = await getPackages();
      dispatch({ type: "", isPackageLoading: false, packages: response });
    } catch (error) {
      if (this.retryCount < 3) {
        this.fetchPackage();
      } else {
        dispatch({
          type: "",
          isShowError: true,
          errorMessage: error.message
        });
        this.backToPreviousPage();
      }
    }
  };

  componentDidMount = () => {
    this.retryCount = 0;
    const { auth } = this.props;
    const { isPackageLoading } = auth;
    if (isPackageLoading === true) {
      this.fetchPackage();
    }
  };

  render = () => {
    const { classes, auth } = this.props;
    const { modalVisible } = this.state;
    const { isPackageLoading, packages = [] } = auth;
    return (
      <Wrapper>
        <Body>
          {isPackageLoading ? (
            <Loading />
          ) : (
            <div className={classes.wrapper}>
              {packages.map(x => {
                return (
                  <div className={classes.card}>
                    <div className={classes.cardHeadContainer}>
                      <Typography className={classes.cardHead}>
                        {x.display_name_th}
                      </Typography>
                      <div
                        className={classes.button}
                        onClick={() => {
                          this.setState({
                            modalVisible: true
                          });
                        }}
                      >
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <ellipse
                            cx="9"
                            cy="9.04757"
                            rx="9"
                            ry="8.64986"
                            fill="#878b96"
                          />
                          <path
                            d="M8.19141 10.6654H9.9375V12.3588H8.19141V10.6654ZM6.05273 6.44666C6.09961 5.33337 6.48828 4.54431 7.21875 4.07947C7.67969 3.78259 8.24609 3.63416 8.91797 3.63416C9.80078 3.63416 10.5332 3.84509 11.1152 4.26697C11.7012 4.68884 11.9941 5.31384 11.9941 6.14197C11.9941 6.64978 11.8672 7.07751 11.6133 7.42517C11.4648 7.63611 11.1797 7.90564 10.7578 8.23376L10.3418 8.55603C10.1152 8.73181 9.96484 8.93689 9.89062 9.17126C9.84375 9.3197 9.81836 9.55017 9.81445 9.86267H8.23242C8.25586 9.20251 8.31836 8.74744 8.41992 8.49744C8.52148 8.24353 8.7832 7.95251 9.20508 7.62439L9.63281 7.29041C9.77344 7.18494 9.88672 7.0697 9.97266 6.9447C10.1289 6.72986 10.207 6.49353 10.207 6.23572C10.207 5.93884 10.1191 5.66931 9.94336 5.42712C9.77148 5.18103 9.45508 5.05798 8.99414 5.05798C8.54102 5.05798 8.21875 5.20837 8.02734 5.50916C7.83984 5.80994 7.74609 6.12244 7.74609 6.44666H6.05273Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                    </div>
                    <Typography className={classes.cardPriceNumber}>
                      ฿ {numeral(x.total_prem).format("0,0")}
                    </Typography>
                    <div className={classes.item}>
                      <Typography className={classes.itemName}>
                        การเจ็บป่วยในภาวะโคม่าจากการติดเชื้อไวรัสโคโรนา
                      </Typography>
                      <Typography className={classes.itemValue}>
                        {numeral(_.get(x, "coverage.illness", 0)).format("0,0")}
                      </Typography>
                    </div>
                    <div className={classes.item}>
                      <Typography className={classes.itemName}>
                        การรักษาพยาบาลต่อปี
                      </Typography>
                      <Typography className={classes.itemValue}>
                        {numeral(
                          _.get(x, "coverage.medical_treatment", 0)
                        ).format("0,0")}
                      </Typography>
                    </div>
                    <br />
                    <SubmitButton onClick={this.goToNextPage(x)}>
                      เลือกแผนประกัน
                    </SubmitButton>
                  </div>
                );
              })}
              <br />
            </div>
          )}
          <Modal
            styles={{ outline: 0 }}
            open={modalVisible}
            onClose={() => {
              this.setState({ modalVisible: false });
            }}
          >
            <div className={classes.modalContainer}>
              <div className={classes.modalContainerContent}>
                <br />
                <Typography className={classes.modalHead}>
                  การเจ็บป่วยในภาวะโคม่าจากการติดเชื้อ ไวรัสโคโรนา
                </Typography>
                <Typography className={classes.modalValue}>
                  การเจ็บป่วยด้วยภาวะโคม่า หรือ ภาวะสมองตายและระบบประสาทล้มเหลว
                  หรือ การเจ็บป่วยระยะสุดท้ายซึ่งเป็นการเจ็บป่วยรุนแรงที่แพทย์
                  ลงความเห็นว่าไม่มีวิธีการรักษาให้หายได้ และ/หรือ
                  เป็นสาเหตุทำให้เสียชีวิตโดยมีสาเหตุหลักมาจากติดเชื้อไวรัสโคโรนา
                </Typography>
                <br />
                <Typography className={classes.modalHead}>
                  การรักษาพยาบาลต่อปี
                </Typography>
                <Typography className={classes.modalValue}>
                  ค่ารักษาพยาบาลกรณีเจ็บป่วยจากการติดเชื้อ ไวรัสโคโรน่า
                  ทั้งกรณีผู้ป่วยในและผู้ป่วยนอก
                </Typography>
                <br />
                <SubmitButton
                  onClick={() => {
                    this.setState({ modalVisible: false });
                  }}
                >
                  ตกลง
                </SubmitButton>
              </div>
            </div>
          </Modal>
        </Body>
        <Header>
          <TopBar arrowLeft={this.backToPreviousPage} progress={1}>
            <Typography align="center" className={classes.textTopBar}>
              เลือกแผนประกัน
            </Typography>
          </TopBar>
        </Header>
      </Wrapper>
    );
  };
}

const mapStateToProps = (state, ownProps) => {
  return {
    auth: state.auth || {}
  };
};

export default connect(mapStateToProps)(withStyles(styles)(App));
